var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    { attrs: { open: _vm.isOpen } },
    [
      _c("template", { slot: "content" }, [
        _c(
          "div",
          {
            staticClass:
              "emd-container _highlight_header _footer_end _footer_spaced_mobile",
          },
          [
            _c("div", { staticClass: "emd-container__header" }, [
              _c(
                "h2",
                { staticClass: "emd-text _size_section _color_secondary" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isActionSetAsEmployee
                          ? _vm.$t("inviteSetAsEmployee")
                          : _vm.$t("inviteEmployee")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "emd-btn _type_link",
                  on: { click: _vm.hideInviteEmployeeCancelled },
                },
                [_c("i", { staticClass: "uil uil-times" })]
              ),
            ]),
            _vm.activeStep.checkUser
              ? _c("form-check-user", {
                  attrs: { fields: _vm.fields },
                  on: {
                    setActiveStep: _vm.setActiveStep,
                    setDataCheckUser: _vm.setDataCheckUser,
                    hideCancelled: _vm.hideInviteEmployeeCancelled,
                  },
                })
              : _vm.activeStep.inviteUser || _vm.activeStep.inviteSetAsEmployee
              ? _c("form-invite-user", {
                  attrs: {
                    fields: _vm.fields,
                    userId: _vm.userId,
                    activeStep: _vm.activeStep,
                    isOpen: _vm.isOpen,
                  },
                  on: {
                    setActiveStep: _vm.setActiveStep,
                    setUserData: _vm.setUserResponseData,
                  },
                })
              : _vm.activeStep.done && _vm.userResponseData
              ? _c("done-step", {
                  attrs: {
                    user: _vm.userResponseData.user,
                    permission: _vm.fields.employee_type.value,
                    action: _vm.userResponseData.action,
                  },
                  on: { done: _vm.hideInviteEmployeeSuccess },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }